var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOTCSalesChannel)?_c('div',{staticClass:"catalog-otc-filters"},_vm._l((_vm.branches),function(branch){return _c('Button',{key:branch.id,attrs:{"modifiers":[
      'small',
      String(_vm.active) === String(branch.id) ? 'primary' : 'secondary',
    ],"on-click":() => _vm.click(branch.id)}},[_vm._v("\n    F"+_vm._s(branch.id)+" ("+_vm._s(branch.name)+")\n  ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }